/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonSharedGenderDropdownQueryResponse,
  GetApiV1PersonSharedGenderDropdown401,
  GetApiV1PersonSharedGenderDropdown500,
} from "../../types/personSharedController/GetApiV1PersonSharedGenderDropdown.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonSharedGenderDropdown } from "../../clients/personSharedController/getApiV1PersonSharedGenderDropdown.ts";

export const getApiV1PersonSharedGenderDropdownQueryKey = () =>
  [{ url: "/api/v1/person/shared/gender-dropdown" }] as const;

export type GetApiV1PersonSharedGenderDropdownQueryKey = ReturnType<
  typeof getApiV1PersonSharedGenderDropdownQueryKey
>;

export function getApiV1PersonSharedGenderDropdownQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonSharedGenderDropdownQueryKey();
  return queryOptions<
    GetApiV1PersonSharedGenderDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedGenderDropdown401
      | GetApiV1PersonSharedGenderDropdown500
    >,
    GetApiV1PersonSharedGenderDropdownQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonSharedGenderDropdown({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todas as opções do enumerador EGender para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Lista de gêneros para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/gender-dropdown}
 */
export function useGetApiV1PersonSharedGenderDropdown<
  TData = GetApiV1PersonSharedGenderDropdownQueryResponse,
  TQueryData = GetApiV1PersonSharedGenderDropdownQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonSharedGenderDropdownQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonSharedGenderDropdownQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonSharedGenderDropdown401
          | GetApiV1PersonSharedGenderDropdown500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1PersonSharedGenderDropdownQueryKey();

  const query = useQuery(
    {
      ...getApiV1PersonSharedGenderDropdownQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonSharedGenderDropdown401
      | GetApiV1PersonSharedGenderDropdown500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
